import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { HiOutlineLockClosed, HiOutlineArrowRight, HiOutlineSparkles } from "react-icons/hi2";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../baseurl";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // Extract token and email from URL
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      return Swal.fire("Error", "Passwords do not match!", "error");
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(`${baseurl}updatePassword`, {
        email,
        token,
        newPassword: password
      });

      Swal.fire({
        icon: 'success',
        title: 'Password Updated!',
        text: 'You can now login with your new password.',
        timer: 3000
      });
      navigate("/login");
    } catch (err) {
      Swal.fire("Error", err.response?.data?.error || "Invalid or expired token", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-hero-wrapper">
      <div className="container login-main-container">
        <div className="login-card shadow-2xl">
          <div className="row g-0 h-100">
            <div className="col-lg-6 d-none d-lg-block side-hero-image">
              <div className="side-hero-overlay p-5 d-flex flex-column justify-content-center">
                <div className="hero-badge mb-4"><HiOutlineSparkles className="me-2" /> Security</div>
                <h1 className="display-4 fw-bold text-white mb-4">Reset <br /> Complete.</h1>
                <p className="text-white-50 lead">Choose a strong password to protect your travel account.</p>
              </div>
            </div>

            <div className="col-lg-6 bg-white p-4 p-md-5 d-flex flex-column justify-content-center">
              <div className="form-content mx-auto" style={{maxWidth: "400px", width: "100%"}}>
                <h2 className="fw-bold text-dark mb-4">Create New Password</h2>
                <form onSubmit={handleUpdatePassword}>
                  <div className="form-floating-custom mb-3">
                    <label className="small fw-bold text-teal">NEW PASSWORD</label>
                    <div className="input-with-icon">
                      <HiOutlineLockClosed className="icon" />
                      <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required placeholder="••••••••" />
                    </div>
                  </div>
                  <div className="form-floating-custom mb-4">
                    <label className="small fw-bold text-teal">CONFIRM PASSWORD</label>
                    <div className="input-with-icon">
                      <HiOutlineLockClosed className="icon" />
                      <input type="password" value={confirmPassword} onChange={(e)=>setConfirmPassword(e.target.value)} required placeholder="••••••••" />
                    </div>
                  </div>
                  <button type="submit" className="btn-hero-login w-100" disabled={isSubmitting}>
                    {isSubmitting ? "Updating..." : "Update Password"} <HiOutlineArrowRight className="ms-2" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;